import { useState, useEffect, useRef } from "react";
import "./blogs.css";
// import { BlogsDataTable } from "views/admin/default/variables/columnsData";
// import tableDataComplex from "../default/variables/tableDataComplex.json";
// import ComplexTable from "views/admin/default/components/ComplexTable";
import { getAllBlog, getProjects } from "proxyUrl";
import BlogTable from "./BlogTable";
// import { GetBookingDataByUserId } from "proxyUrl";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
const Blogs = () => {
  const [blogData, setBlogData] = useState([]);
  const [titleFilter, setTitleFilter] = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const debounceTimerRef = useRef(null);

  // console.log(user)
  const currentUser = useSelector((state) => state.user.user.userRole.name);
  console.log(currentUser);
  
  const fetchData = (title = "", type = "") => {
    setLoading(true);
    const params = {};
    if (title && title.trim()) {
      params.title = title.trim();
    }
    if (type && type.trim()) {
      params.type = type.trim();
    }

    axios
      .get(getAllBlog, {
        params: params,
        withCredentials: true,
        paramsSerializer: {
          // Use encodeURIComponent to encode spaces as %20 instead of +
          encode: (param) => encodeURIComponent(param)
        }
      })
      .then((res) => {
        // Handle both res.data and res.data.data structures
        const blogData = res.data?.data || res.data || [];
        setBlogData(blogData);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setBlogData([]);
      });
  };

  const getProductsData = async () => {
    await axios
      .get(getProjects)
      .then((res) => {
        setProducts(res.data.data);
      })
      .catch((err) => {
        console.log(err);
        setProducts([]);
      });
  };

  const isInitialMount = useRef(true);

  useEffect(() => {
    getProductsData();
    fetchData();
    isInitialMount.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Debounce title filter to avoid too many API calls
  useEffect(() => {
    // Skip on initial mount
    if (isInitialMount.current) {
      return;
    }

    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    debounceTimerRef.current = setTimeout(() => {
      fetchData(titleFilter, typeFilter);
    }, 500); // 500ms debounce for title input

    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [titleFilter]);

  // Fetch data immediately when type filter changes
  useEffect(() => {
    // Skip on initial mount
    if (isInitialMount.current) {
      return;
    }
    fetchData(titleFilter, typeFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeFilter]);

  // console.log(user.length);
  return (
    <>
      <div className=" add-booking-header  relative  mx-4 mt-6 flex justify-between rounded-2xl bg-primaryBlue p-3 shadow-lg dark:bg-navy-800">
        <div className="text-xl font-bold text-white  dark:text-white">
          All Blog
        </div>
        <Link to="/admin/blogs/add">
          <button className="rounded-full bg-white p-1  px-3 text-navy-800 dark:bg-navy-900 dark:text-white">
            Add Blog
          </button>
        </Link>
      </div>
      <div className="relative -mt-7  grid w-full grid-cols-1 gap-0 md:grid-cols-1">
        {/* Filter Section */}
        <div className="mx-4 mb-4 flex flex-col gap-4 rounded-lg bg-white p-4 shadow-lg dark:bg-navy-800 sm:flex-row mt-5">
          <div className="flex-1">
            <label htmlFor="title-filter" className="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
              Filter by Title
            </label>
            <input
              id="title-filter"
              type="text"
              placeholder="Search by title..."
              value={titleFilter}
              onChange={(e) => setTitleFilter(e.target.value)}
              className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-primaryBlue focus:outline-none focus:ring-1 focus:ring-primaryBlue dark:border-gray-600 dark:bg-gray-700 dark:text-white"
            />
          </div>
          <div className="flex-1">
            <label htmlFor="type-filter" className="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
              Filter by Type
            </label>
            <select
              id="type-filter"
              value={typeFilter}
              onChange={(e) => setTypeFilter(e.target.value)}
              className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-primaryBlue focus:outline-none focus:ring-1 focus:ring-primaryBlue dark:border-gray-600 dark:bg-gray-700 dark:text-white"
            >
              <option value="">All Types</option>
              {products && products.length > 0 ? (
                products.map((product, index) => (
                  <option key={index} value={product.id}>
                    {product.name}
                  </option>
                ))
              ) : (
                <option value="">No types available</option>
              )}
            </select>
          </div>
        </div>
        {/* <TotalSpent /> */}
        {/* <WeeklyRevenue /> */}
        {loading ? (
          <div className="mx-4 flex items-center justify-center py-8">
            <div className="text-gray-600 dark:text-gray-400">Loading...</div>
          </div>
        ) : Array.isArray(blogData) && blogData.length > 0 ? (
          <>
          <BlogTable
           
            columnLenghth={blogData.length}
            tableData={blogData}
            editRoute={`/admin/blogs/edit`}
            deleteRoute={`/admin/blogs/delete`}
          />
        </>
        ) : (
          <div className="mx-4 flex items-center justify-center py-8">
            <div className="text-gray-600 dark:text-gray-400">No blogs found</div>
          </div>
        )}
      </div>
    </>
  );
};

export default Blogs;
